if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) {
              if (this.querySelector('.product-card')) {
                this.dispatchEvent(new CustomEvent('recommendations:loaded'));
              }
              return;
            }

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            const fetchedProduct = recommendations && recommendations.querySelector('.product-card');

            if (fetchedProduct) {
              this.innerHTML = recommendations.innerHTML;
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else if (this.querySelector('.product-card')) {
              // Keep the editable fallback products already rendered by Liquid.
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (this.classList.contains('complementary-products')) {
                this.closest('.product__block')?.remove();
              } else {
                this.closest('.shopify-section')?.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
